<template>
  <div class="lumbresign-document-new-or-edit wrapper-content w-100" :class="{'hide-dz-success': isHideDzSuccess}" id="resolucion-new-or-edit">
    <h1>{{titulo}}</h1>
    <LmBreadcrumb v-if="showBreadcrumb" />
    <div v-if="!form.permiteGuardar" class="estado-sentencia">
      <h2>{{form.titulo}}</h2>
      <a-steps v-if="stepsDirection === 'horizontal'" :current="form.steps.position" size="small">
        <a-step
          v-for="(item, index) in form.steps.items"
          :key="`step-${index}`"
          :title="item.title" :description="item.description"
        />
      </a-steps>
    </div>
    <LmForm ref="lmFormRef">
      <div class="row" v-if="observaciones.items.length">
        <div class="col-12 mb-2">
          <b-button v-b-toggle.collapse-1 variant="primary" class="float-right observaciones-button">{{observacionesButtonText}}</b-button>
          <b-collapse
            id="collapse-1"
            class="mt-2 col-lg-4 col-12 position-absolute lm-collapse"
            @show="observacionesButtonText = 'Ocultar observaciones'"
            @hide="observacionesButtonText = 'Ver observaciones'"
            >
            <b-list-group>
              <b-list-group-item
              v-for="(observacion, index) in observaciones.items"
              :key="`observacion-${index}`"
              class="flex-column align-items-start">
                <div class="d-flex w-100 justify-content-between">
                  <h5 class="mt-3 mb-1">{{observacion.d_usuario}}</h5>
                  <small>{{observacion.f_alta}}</small>
                </div>
                <p class="mb-1">
                  {{observacion.d_observacion}}
                </p>
              </b-list-group-item>
            </b-list-group>
          </b-collapse>
        </div>
      </div>

      <div v-if="form.permiteGuardar">
        <div class="row">
          <LmTreeSelect
            class="col-12"
            v-model="contentTemplate"
            :options="contentTemplateOptions"
            label="Seleccione un template de contenido"
            placeholder="Seleccione un template de contenido"
            @input="onContentTemplateChange"
          />
          <LmTextInput
            autofocus
            class="col-12"
            v-model="form.titulo"
            label="Título"
            :v="$v.form.titulo"
            />
            <div class="col-12 formBuilderSection">
              <hr>
              <LmFormBuilder
                ref="lmFormBuilder"
                @formBuilderInitialized="cleanupFormBuilderTitle"
                :endpointUriwhereGetComponents="`formbuilder/${this.customFormBuilderId}`"
                :endpointUriWhereGetValuesToLoadInEditMode="$route.params.id && `decretos/edit/${$route.params.id}`"
                :contentTemplateData="form"
                @formObjectToSendToServerChange="updateForm($event)"
                />
            </div>
        </div>
        <hr>
        <h4>Secciones</h4>
        <div
          v-for="(articulo, index) in form.articulos"
          :key="`decreta-${index}`"
          class="row">
          <LmEditor
            ref="lmEditor"
            class="col-10 col-lg-10"
            v-model="form.articulos[index].articuloContent"
            @onUpdate="form.articulos[index].articuloContent = $event"
            :contentProps="form.articulos[index].articuloContent"
          />
          <button
            class="btn btn-link text-danger col-2 mt-5"
            @click="form.articulos.splice(index, 1)"
            :disabled="form.articulos.length <= 1"
            >
            <font-awesome-icon icon="trash" />
            <span class="ml-1">Eliminar</span>
          </button>
        </div>
        <LmButton
          id="new-article"
          type="button"
          value="Nueva Sección"
          @click.native="form.articulos.push({ articuloContent: '' })"
          buttonClass="btn-primary btn-sm"
          lmButtonWrapperClass="col-auto"
          lmButtonRootWrapperClass="d-inline-block mr-1"
        />
        <hr>
        <div class="row">
          <h4 class="col-12">Archivos</h4>
        </div>
        <div class="row">
          <div class="col-12">
            <draggable
              tag="b-list-group"
              v-model="form.anexos"
              group="people"
              @start="drag=true"
              @end="drag=false"
              >
                <b-list-group-item
                  v-for="(file, index) in form.anexos"
                  :key="index"
                  class="d-flex justify-content-between"
                  >
                  <font-awesome-icon class="bar mr-2" icon="bars" />
                  <button
                    type="button"
                    v-b-modal.anexosModal
                    class="btn btn-link p-0  text-truncate text-left w-100"
                    @click="setAnexosModalFile(file)"
                    >{{file.originalname}}</button>
                  <div class="d-flex justify-content-end align-items-center">
                    <b-badge variant="primary file-size">{{ formatBytes(file.size) }}</b-badge>
                    <font-awesome-icon class="close ml-3" icon="times" @click="deleteUploadFile(index)"/>
                  </div>
                </b-list-group-item>
            </draggable>
          </div>
          <LmUploadFiles
            ref="lmUploadFiles"
            class="mb-3 col-12"
            :dropzoneOptions="dropzoneOptions"
            dictDefaultMessage='Arrastre el archivo pdf hasta aquí para subirlo'
            @vdropzone-removed-file="fileRemoved"
            @vdropzone-success="fileCreated"
            @vdropzone-error="dropzoneErrorHandler"
          />
          <div
            class="mb-3 col-12"
            >
            <b-alert
              v-for="(dropzoneError, index) in dropzoneErrors"
              :key='index'
              :show="5"
              :variant="dropzoneError.variant"
              @dismissed="dropzoneErrors.splice(index, 1)"
              fade
              >{{dropzoneError.message}}</b-alert>
          </div>
        </div>
        <hr>
        <div class="row">
          <h4 class="col-12">Firman</h4>
          <LmTreeSelect
            multiple
            label="Firmantes"
            placeholder="Firmantes"
            class="col-6"
            v-model="form.refrenda"
            :pathToGetOptions="lmSuperPowerSelects.refrenda.path"
          />
          <div class="col-6">
            <draggable
              tag="b-list-group"
              v-model="form.refrenda"
              @start="drag=true"
              @end="drag=false"
              >
                <b-list-group-item
                  v-for="(item, index) in form.refrenda"
                  :key="index"
                  class="d-flex justify-content-between"
                  >
                  <font-awesome-icon class="bar mr-2" icon="bars" />
                  {{item.name}}
                  <div class="d-flex justify-content-end align-items-center">
                    <font-awesome-icon class="mr-2" icon="fingerprint"/>
                    <b-badge variant="primary file-size">{{ index + 1 }}</b-badge>
                    <!-- <font-awesome-icon class="close ml-3" icon="times" @click="deleteUploadFile(index)"/> -->
                  </div>
                </b-list-group-item>
            </draggable>
          </div>
        </div>
        <hr>
        <div class="row">
          <h4 class="col-12">Tome conocimiento</h4>
          <LmTreeSelect
            multiple
            label="Responsables"
            placeholder="Responsables"
            class="col-12"
            v-model="form.tomeConocimiento"
            :pathToGetOptions="lmSuperPowerSelects.tomeConocimiento.path"
          />
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div v-if="stepsDirection === 'vertical'" class="col-sm-12 col-md-2">
            <a-steps :current="form.steps.position" size="small" direction="vertical">
              <a-step
                v-for="(item, index) in form.steps.items"
                :key="`step-${index}`"
                :title="item.title" :description="item.description"
              />
            </a-steps>
          </div>
          <div :class="pdfViewerColumns">
            <iframe id="pdfViewer" v-if="form.PDFUrl" :src="form.PDFUrl" width="100%" :height="pdfViewerHeight"/>
          </div>
        </div>
      </div>
      <hr>
      <LmButton
        id="btn-cancel"
        type="button"
        buttonClass="btn-secondary"
        :isProcessing="formIsProcessing"
        :value="$t('go_back')"
        @click.native="cancelBtn"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
      />
      <LmButton
        id="btn-submit"
        type="submit"
        buttonClass="btn-primary"
        :isProcessing="formIsProcessing"
        :value="$t('Save')"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="save"
        v-if="form.permiteGuardar"
      />
      <LmButton
        id="btn-submit-enviar-a-firmar"
        type="submit"
        buttonClass="btn-success"
        :isProcessing="formIsProcessing"
        value="Guardar y Enviar a Firmar"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="enviaraFirmar"
        v-if="form.permiteGuardar"
      />
      <LmButton
        id="btn-submit-aprobar-visado"
        type="submit"
        buttonClass="btn-success"
        :isProcessing="formIsProcessing"
        value="Aprobar"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="aprobarVisado"
        v-if="form.permiteVisar && isOnEditMode"
      />
      <LmButton
        id="btn-submit-rechazar-visado"
        type="submit"
        buttonClass="btn-danger"
        :isProcessing="formIsProcessing"
        value="Rechazar"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="rechazarVisado"
        v-if="form.permiteVisar && isOnEditMode"
      />
      <LmButton
        id="btn-submit-firmar-via-firmador"
        type="submit"
        buttonClass="btn-success"
        :isProcessing="formIsProcessing"
        value="Firmar"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="firmarViaFirmador"
        v-if="form.permiteFirmar"
      />
      <LmButton
        id="btn-submit-firmar-via-token"
        type="submit"
        buttonClass="btn-success"
        :isProcessing="formIsProcessing"
        value="Firmar Electrónicamente"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="firmarViaToken"
        v-if="form.permiteFirmarViaToken"
      />
      <LmButton
        id="btn-submit-rechazar-firmado"
        type="submit"
        buttonClass="btn-danger"
        :isProcessing="formIsProcessing"
        value="Rechazar"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="rechazarFirmado"
        v-if="form.permiteFirmar || form.permiteFirmarViaToken"
      />
      <LmButton
        id="btn-submit-tomar-control"
        type="submit"
        buttonClass="btn-danger"
        :isProcessing="formIsProcessing"
        value="Tomar Control"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="tomarControlDecreto"
        v-if="form.permiteTomarControl && !form.permiteGuardar"
      />
      <LmButton
        id="btn-submit-guardar-como-template"
        type="submit"
        buttonClass="btn-info"
        :isProcessing="formIsProcessing"
        value="Guardar como template"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="$refs.saveContentTemplateModal.show()"
        v-if="form.permiteGuardarComoTemplate"
      />
      <LmButton
        id="btn-submit-tomar-control"
        type="submit"
        buttonClass="btn-info"
        :isProcessing="formIsProcessing"
        value="Historial"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        @click.native="goToHistorialBtn"
        v-if="!form.permiteGuardar"
      />
    </LmForm>
    <lmConfirmationModal ref="lmConfirmationModalAprobar" title="Aviso" message="Va a enviar a firmar la sentencia.  ¿Está seguro?"/>
    <lmConfirmationModal ref="lmConfirmationModalVisado" title="Aviso" message="Va a enviar la sentencia a Visado Interno.  ¿Está seguro?"/>
    <lmConfirmationModal ref="lmConfirmationModalEnviaraFirmar" title="Aviso" message="Va a enviar a firmar la sentencia.  ¿Está seguro?"/>
    <lmConfirmationModal ref="lmConfirmationModalFirmar" title="Aviso" message="Va a iniciar el proceso de firma de la sentencia.  ¿Está seguro?"/>
    <lmConfirmationModal ref="lmConfirmationModalTomarControl" title="Aviso" message="Está por tomar control de la sentencia.  ¿Está seguro?"/>
    <LmSuggestionModal
      ref="LmSuggestionModal"
      title="Motivo del Rechazo"
      info="<p>Escriba la observación sobre la presente sentencia,<strong> tenga en cuenta que esta acción</strong> vuelve la sentencia a Edición e <strong>invalida todas la firmas digitales previas</strong>, si existen</p>"
      :textAreaSetup="{
        id: 'reason',
        label: 'Motivo',
        placeholder: 'Motivo'
      }"
    />
    <b-modal
      id="lm-create-segment-modal"
      ref="saveContentTemplateModal"
      :title="contentTemplate ? 'Actualiza tu template' : 'Crea un nombre para el template'"
      :ok-title="contentTemplate ? 'Actualizar' : 'Crear'"
      :cancel-title="$t('Cancel')"
      @ok="guardarComoTemplate"
    >
      <form
        id="lm-create-segment-modal-form"
        novalidate
        class="position-relative"
        @submit.prevent
      >
        <LmTextInput
          id="inputTitle"
          v-model="contentTemplateName"
          label="Nombre"
          placeholder="Un nombre para referenciar el template"
          ref="inputTitle"
        />
      </form>
    </b-modal>
    <lmConfirmationModal ref="lmConfirmationModalFirmarToken" title="Aviso" message="Va a iniciar el proceso de firma electrónica de la sentencia.  ¿Está seguro?"/>
    <lmConfirmationModal ref="lmValidationModalFirmarToken" title="Aviso" message="Un código fue enviado a su mail, por favor ingreselo a continuación." @ok="setToken"/>
    <b-modal id="decretoPDFModal" title="Sentencia PDF" size="lg" >
    </b-modal>
    <b-modal id="anexosModal" :title="anexosModalFile.name" size="xl" hide-footer >
      <iframe :src="anexosModalFile.src" frameborder="0" style="height:75vh;" width="100%"></iframe>
    </b-modal>
  </div>
</template>

<script>
import LmForm from '@/components/form/LmForm.vue'
import LmTextArea from '@/components/form/elements/LmTextArea.vue'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2.vue'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect.vue'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
import lmFormatBytes from '@/mixins/lmFormatBytes.js'
import lmToasts from '@/mixins/lmToasts.js'
import LmButton from '@/components/form/elements/LmButton'
import lmConfirmationModal from '@/components/modals/LmConfirmationModal'
import LmSuggestionModal from '@/components/modals/LmSuggestionModal'
import LmEditor from '@/components/form/elements/lmEditor'
import commonsApi from '@/api/commons'
import LmUploadFiles from '@/components/LmUploadFiles.vue'
import draggable from 'vuedraggable'
import LmFormBuilder from '@/components/LmFormBuilder'

import store from '@/store'
import { mapActions } from 'vuex'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'

export default {
  mixins: [lmSuperPowerSelectHelper, lmToasts, lmFormatBytes],
  components: {
    LmForm,
    LmTextArea,
    LmTextInput,
    LmSuperPowerSelect,
    LmSuperPowerSelectV2,
    LmButton,
    lmConfirmationModal,
    LmEditor,
    LmNumberInput,
    LmSuggestionModal,
    LmUploadFiles,
    draggable,
    LmFormBuilder,
    LmTreeSelect
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      dropzoneErrors: [],
      anexosModalFile: {
        src: '',
        name: ''
      },
      isHideDzSuccess: false,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}upload/`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${store.state.session.accessToken}`
        },
        withCredentials: true,
        thumbnailWidth: 150,
        addRemoveLinks: true,
        acceptedFiles: 'application/pdf'
      },
      lmUploadFiles: [],
      observacionesButtonText: 'Ver observaciones',
      lmSuperPowerSelects: {
        refrenda: {
          selectOptions: [],
          path: '/users/all',
          tbColumns: [
            { title: 'Firmantes', data: 'name' } // Refrenda
          ]
        },
        tomeConocimiento: {
          selectOptions: [],
          path: 'codificatorbuilder/codificators/60ef334457c5ac23d879c100', // 'codificatorbuilder/codificators/60ef334457c5ac23d879c100/60ef32cd57c5ac23d879c0fe',
          tbColumns: [
            { title: 'Responsables', data: 'name' } // Tome Conocimiento
          ]
        },
        aniosExpedientesAsciados: {
          selectOptions: [],
          tbColumns: [
            { title: 'Año', data: 'name' },
            { title: '(Cant.)', data: 'count' }
          ]
        }
      },
      form: {
        titulo: '',
        idClasificacion: null,
        idSubclasificacion: null,
        articulos: [{ articuloContent: '' }],
        numeroExpedienteAsociado: '',
        seccionVisto: '',
        seccionConsiderando: '',
        seccionFinal: 'POR ELLO:',
        refrenda: [],
        tomeConocimiento: [],
        permiteGuardar: !this.isOnEditMode,
        permiteVisar: false,
        permiteFirmar: false,
        permiteFirmarViaToken: false,
        permiteGuardarComoTemplate: true,
        steps: {
          items: [],
          position: 0,
          progress: 0
        },
        anexos: [],
        clasificacion: null,
        subclasificacion: null
      },
      superPowerRefrendadas: [],
      refrendaOrder: [],
      observaciones: {
        total: 0,
        items: []
      },
      initialForm: {},
      formIsProcessing: false,
      requireAllFields: false,
      otpToken: '',
      contentTemplate: null,
      contentTemplateRef: 'sentencias',
      contentTemplateName: null,
      contentTemplateOptions: []
    }
  },
  computed: {
    titulo: {
      get () {
        return this.isOnEditMode ? 'Editar' : 'Nueva Sentencia'
      },
      set () {}
    },
    stepsDirection: {
      get () {
        return this.form.steps.items.length > 6 ? 'vertical' : 'horizontal'
      },
      set () {}
    },
    pdfViewerColumns: {
      get () {
        return this.stepsDirection === 'vertical' ? 'col-sm-12 col-md-10' : 'col-12'
      },
      set () {}
    },
    pdfViewerHeight: {
      get () {
        return this.stepsDirection === 'vertical' ? '100%' : '700px'
      },
      set () {}
    },
    contentTemplatePath: {
      get () {
        return `contenttemplate/${this.contentTemplateRef}/all`
      },
      set (val) {}
    }
  },
  validations () {
    return {
      form: {
        titulo: {
          required
        },
        /*
        seccionVisto: {
          required: requiredIf(function () {
            return this.requireAllFields
          })
        },
        seccionConsiderando: {
          required: requiredIf(function () {
            return this.requireAllFields
          })
        },
        */
        articulos: {
          minLength: minLength(1)
          /*
          ,
          $each: {
            articuloContent: {
              required: requiredIf(function () {
                return this.requireAllFields
              })
            }
          }
          */
        },
        anexos: {
          maxLength: maxLength(this.anexosLimit)
        }
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    onSuccessDestinationRoute: {
      type: String,
      required: true,
      default: '/'
    },
    newOrEditEndpointUri: {
      type: String,
      required: true
    },
    isOnEditMode: {
      type: Boolean,
      required: true,
      default: false
    },
    jnlpGeneratorPath: {
      type: String,
      required: true
    },
    anexosLimit: {
      type: Number,
      required: false,
      default: 40
    },
    customFormBuilderId: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    // Seteo las opciones para el super power de content template
    async setContentTemplateOptions () {
      this.contentTemplateOptions = await commonsApi.getSelectOptions({
        path: this.contentTemplatePath
      })
      console.log('setContentTemplateOptions vale: ', this.contentTemplateOptions)
    },
    // Funcion que guarda el contenido de this.form como content template o actualiza un template ya creado
    async guardarComoTemplate (bvModalEvt) {
      bvModalEvt.preventDefault()
      try {
        let res = ''
        if (this.contentTemplate === null) {
          res = await commonsApi.axiosPostWrapper('/contenttemplate', {
            name: this.contentTemplateName,
            ref: this.contentTemplateRef,
            template: this.form
          })
          console.log('template vale: ', { ...this.form, ...this.$refs.lmFormBuilder.formObjectToSendToServer })
          this.lmToastSuccessMessage(`Se creó el template ${this.contentTemplateName}.`, `Operación realizada con éxito.`)
        } else {
          res = await commonsApi.axiosPutWrapper(`/contenttemplate/${this.contentTemplate.id}`, {
            name: this.contentTemplateName,
            ref: this.contentTemplateRef,
            // template: this.form
            template: { ...this.form, ...this.$refs.lmFormBuilder.formObjectToSendToServer }
          })
          this.lmToastSuccessMessage(`Se actualizó el template ${this.contentTemplateName}.`, `Operación realizada con éxito.`)
        }
        await this.setContentTemplateOptions()
        // Cargo el template creado o actualizado como seleccionado en el super power
        this.contentTemplate = {
          id: res.data._id || res.data.id,
          name: res.data.name,
          ref: res.data.ref
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.$refs.saveContentTemplateModal.hide()
      }
    },
    updateForm (event) {
      this.form = Object.assign({}, this.form, event)
    },
    setToken (data) {
      this.otpToken = data.comment
    },
    setAnexosModalFile (file) {
      this.anexosModalFile.src = process.env.VUE_APP_API_URL_STATIC_ASSETS + file.path
      this.anexosModalFile.name = file.originalname
    },
    deleteUploadFile (index) {
      this.form.anexos.splice(index, 1)
      this.lmUploadFiles.splice(index, 1)
    },
    fileCreated (file, response) {
      if (response) {
        this.isHideDzSuccess = false
        this.form.anexos.push(response)
        setTimeout(() => {
          this.isHideDzSuccess = true
        }, 1000)
      }
    },
    fileRemoved (file, error, xhr) {
      this.form.urlimagen = ''
      if (file) {
        this.form.anexos = this.form.anexos.filter(f => f.name !== file.name)
        this.$forceUpdate()
      }
    },
    dropzoneErrorHandler (file) {
      const error = {
        variant: '',
        message: ''
      }
      if (file?.xhr?.status === 413) {
        const maxValueAllowedByServe = JSON.parse(file?.xhr?.response).message.match(/\d+/g)[0]
        error.message = `Lo sentimos, el tamaño del archivo "${file.name}" excede el tamaño máximo permitido ${this.formatBytes(maxValueAllowedByServe)}`
        error.variant = 'danger'
      } else if (file.type !== 'application/pdf') {
        error.message = 'Lo sentimos, sólo puede subir archivos en formato PDF'
        error.variant = 'warning'
      } else {
        error.message = file?.xhr?.response ? JSON.parse(file?.xhr?.response).message : ''
        error.variant = 'danger'
      }
      this.$refs.lmUploadFiles.lmRemoveFile(file)
      this.dropzoneErrors.push(error)
    },
    cleanupFormBuilderTitle () {
      // Una manera rapida de ocultar el titulo que por defecto deja formbuilder
      this.$refs.lmFormBuilder.pageTitleData = ''
    },
    async setForm () {
      if (this.isOnEditMode) {
        await this.$refs.lmFormRef.activeEditMode({
          path: 'decretos/edit/',
          id: this.$route.params.id
        })
          .catch(error => {
            console.log(error)
            this.$router.replace({ name: '404' })
          })

        this.observaciones = await commonsApi.getItemDetail({
          path: 'decretos/observaciones',
          id: this.$route.params.id
        })
          .catch(error => {
            console.log(error)
            return {
              total: 0,
              items: []
            }
          })
      } else {
        this.$nextTick(function () {
          this.$refs.lmEditor[0].editor.commands.clearContent()
          // this.$refs.lmEditorSeccionVisto.editor.commands.clearContent()
          // this.$refs.lmEditorSeccionConsiderando.editor.commands.clearContent()
        })
        this.form = JSON.parse(this.initialForm)
        this.form.permiteGuardar = true
        this.form.permiteVisar = true
      }
    },
    async updateFormContent (value) {
      if (value?.id !== '') {
        try {
          const url = 'contenttemplate/' + value.id
          const response = await commonsApi.axiosGetWrapper(url)
          this.form = response.data.template
        } catch (error) {
          console.log(error)
        }
      }
    },
    goBackBtn () {
      this.$router.go(-1)
    },
    cancelBtn () {
      this.$router.go(-1)
    },
    goToHistorialBtn () {
      this.$router.push(`/documentos/historial/${this.$route.params.id}`)
    },
    async save () {
      this.requireAllFields = false
      this.submit()
    },
    async enviaraFirmar () {
      try {
        this.requireAllFields = true
        await this.$refs.lmFormRef.validationForm(this.$v)
        if (this.form.refrenda.length === 0) {
          this.$refs.lmFormRef.showToastFormError('Debe definir los firmantes')
          return
        }
        await this.$refs.lmFormRef.validationForm(this.$v)
        await this.$refs.lmConfirmationModalEnviaraFirmar.lmShow()
        await this.submit('enviarafirmar')
      } catch (error) {
        this.formIsProcessing = false
      }
    },
    async aprobarVisado () {
      try {
        this.formIsProcessing = true
        await this.$refs.lmConfirmationModalAprobar.lmShow()
        let response = await this.updateItemDetail({
          path: 'decretos/aprobarvisado/',
          data: {
            id: this.$route.params.id
          }
        })
        this.formIsProcessing = false
        if (response.id) {
          this.lmToastSuccessInternalLink(`/documentos/sentencia/editar/${response.id}`, 'Ver Detalle', 'Sentencia Enviada a firmar')
          this.$router.push('/documentos/todos')
        }
      } catch (error) {
        this.formIsProcessing = false
        console.log(error)
      }
    },
    async rechazarVisado () {
      try {
        this.formIsProcessing = true
        const suggestionResponse = await this.$refs.LmSuggestionModal.lmShow()
        let response = await this.updateItemDetail({
          path: 'decretos/rechazarvisado/',
          data: {
            id: this.$route.params.id,
            reason: suggestionResponse.content
          }
        })
        this.formIsProcessing = false
        if (response.id) {
          this.lmToastSuccessInternalLink(`/documentos/sentencia/editar/${response.id}`, 'Ver Detalle', 'Sentencia Rechazada')
          this.$router.push('/documentos/todos')
        }
      } catch (error) {
        this.formIsProcessing = false
        console.log(error)
      }
    },
    async rechazarFirmado () {
      try {
        this.formIsProcessing = true
        const suggestionResponse = await this.$refs.LmSuggestionModal.lmShow()
        let response = await this.updateItemDetail({
          path: 'decretos/rechazarfirmado/',
          data: {
            id: this.$route.params.id,
            reason: suggestionResponse.content
          }
        })
        this.formIsProcessing = false
        if (response.id) {
          this.lmToastSuccessInternalLink(`/documentos/sentencia/editar/${response.id}`, 'Ver Detalle', 'Sentencia Rechazada')
          this.$router.push('/documentos/todos')
        }
      } catch (error) {
        this.formIsProcessing = false
        console.log(error)
      }
    },
    async tomarControlDecreto () {
      try {
        this.formIsProcessing = true
        await this.$refs.lmConfirmationModalTomarControl.lmShow()
        let response = await this.updateItemDetail({
          path: 'decretos/tomarcontrol/',
          data: {
            id: this.$route.params.id
          }
        })
        this.formIsProcessing = false
        if (response.id) {
          this.setForm()
        }
      } catch (error) {
        this.formIsProcessing = false
        console.log(error)
      }
    },
    async firmarViaFirmador () {
      try {
        this.formIsProcessing = true
        await this.$refs.lmConfirmationModalFirmar.lmShow()
        this.formIsProcessing = false
        const tempLink = document.createElement('a')
        tempLink.href = `${process.env.VUE_APP_API_URL}${this.jnlpGeneratorPath}${this.$route.params.id}`
        tempLink.setAttribute('download', `documento_afirmar.jnlp`)
        tempLink.click()
        this.lmToastSuccessInternalLink(`/documentos/sentencia/editar/${this.$route.params.id}`, 'Ver Detalle', 'Sentencia enviada al firmador')
        setTimeout(() => {
          this.$router.push('/documentos/todos')
        }, 1000)
      } catch (error) {
        this.formIsProcessing = false
        console.log(error)
      }
    },
    async firmarViaToken () {
      try {
        this.formIsProcessing = true
        await this.$refs.lmConfirmationModalFirmarToken.lmShow()
        await commonsApi.axiosPostWrapper(`otp/generate`, this.form)
        // this.lmToastSuccessMessage(`Se envió un código a su correo electrónico`, `Por favor ingreselo en el siguiente formulario`)
        this.$refs.lmValidationModalFirmarToken.setIsCommentProps(true, true, 'Codigo')
        await this.$refs.lmValidationModalFirmarToken.lmShow()
        await commonsApi.axiosPostWrapper(`decretos/firmaelectronica`, {
          id: this.$route.params.id,
          token: this.otpToken
        })
        this.formIsProcessing = false
        this.lmToastSuccessInternalLink(`/documentos/sentencia/editar/${this.$route.params.id}`, 'Ver Detalle', 'Sentencia Firmada')
        setTimeout(() => {
          this.$router.push('/documentos/todos')
        }, 1000)
      } catch (error) {
        this.formIsProcessing = false
        console.log(error)
      }
    },
    async submit (accionLuegoDeGuardar = '') {
      try {
        let decretoId = false
        if (this.isOnEditMode) {
          await this.$refs.lmFormRef.validationForm(this.$v)
          this.formIsProcessing = true
          /**
           * Se persisten los datos
           */
          let saveData = {
            id: this.$route.params.id,
            titulo: this.form.titulo,
            idClasificacion: this.form.idClasificacion,
            idSubclasificacion: this.form.idSubclasificacion,
            visto: '', // this.form.seccionVisto,
            considerando: '', // this.form.seccionConsiderando,
            final: '', // this.form.seccionFinal,
            articulos: this.form.articulos,
            refrenda: this.form.refrenda,
            tomeConocimiento: this.form.tomeConocimiento,
            anexos: this.form.anexos,
            lmlKind: 'sentencia',
            ...this.$refs.lmFormBuilder.formObjectToSendToServer
          }
          try {
            let response = await this.updateItemDetail({
              path: 'decretos/update/',
              data: saveData
            })
            if (response.id) {
              decretoId = response.id
            }
          } finally {
            this.formIsProcessing = false
          }
        } else {
          await this.$refs.lmFormRef.validationForm(this.$v)
          this.formIsProcessing = true
          /**
           * Se persisten los datos
           */
          let saveData = {
            titulo: this.form.titulo,
            idClasificacion: this.form.idClasificacion,
            idSubclasificacion: this.form.idSubclasificacion,
            visto: '', // this.form.seccionVisto,
            considerando: '', // this.form.seccionConsiderando,
            final: '', // this.form.seccionFinal,
            articulos: this.form.articulos,
            refrenda: this.form.refrenda,
            tomeConocimiento: this.form.tomeConocimiento,
            anexos: this.form.anexos,
            lmlKind: 'sentencia',
            ...this.$refs.lmFormBuilder.formObjectToSendToServer
          }
          try {
            let response = await this.updateItemDetail({
              path: 'decretos/new/',
              data: saveData
            })
            if (response.id) {
              decretoId = response.id
            }
          } finally {
            this.formIsProcessing = false
          }
        }

        try {
          this.formIsProcessing = true
          if (accionLuegoDeGuardar === 'enviarafirmar') {
            if (decretoId) {
              let response = await this.updateItemDetail({
                path: 'decretos/enviarafirmar/',
                data: {
                  id: decretoId
                }
              })
              this.formIsProcessing = false
              if (response.id) {
                this.lmToastSuccessInternalLink(`/documentos/sentencia/editar/${response.id}`, 'Ver Detalle', 'Sentencia Enviada a Firmar')
                this.$router.push('/documentos/todos')
              }
            }
          } else {
            this.formIsProcessing = false
            if (decretoId) {
              let mensaje = ''
              if (this.isOnEditMode) {
                mensaje = 'Sentencia Actualizada'
              } else {
                mensaje = 'Nueva Sentencia Guardada'
              }
              this.lmToastSuccessInternalLink(`/documentos/sentencia/editar/${decretoId}`, 'Ver Detalle', mensaje)
              this.$router.push('/documentos/todos')
            }
          }
        } finally {
          this.formIsProcessing = false
        }
      } catch (error) {
        console.log(error)
      }
    },
    onContentTemplateChange (event) {
      if (event) {
        this.updateFormContent(event)
        this.contentTemplateName = event.name
      } else {
        this.form = JSON.parse(this.initialForm)
      }
    }
  },
  watch: {
    'form.refrenda' (val) {
      this.refrendaOrder = val.map(i => i.id)
    },
    '$route.path' () {
      this.setForm()
    },
    isOnEditMode () {
      this.setForm()
    }
  },
  async created () {
    this.initialForm = JSON.stringify(this.form)
    await this.setContentTemplateOptions()
  },
  mounted () {
    this.setForm()
  }
}
</script>

<style lang="sass" scoped>
.lumbresign-document-new-or-edit
  .lm-collapse
    top: 35px
    right: 0
    z-index: 1
  .observaciones-button
    min-width: 163px
  .estado-sentencia
    h2
      margin-bottom: 40px
    margin-top: 20px
    margin-bottom: 40px
  .collapsing
    transition: none
  .close
    cursor: pointer
    font-size: 20px
  .bar
    cursor: grab
    font-size: 20px
  .f-icon
    top: 3px
    position: relative
  .file-name
    width: 50%
    @media(min-width: $lg)
      width: 70%
  .file-size
    line-height: 1.5
  #pdfViewer
    min-height: 500px
  .formBuilderSection
    #LmFormBuilder
      padding-left: 0
      padding-rigth: 0
</style>
